import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  activeClasses: {
    id: 'schedule-filters.chips.active-classes',
    defaultMessage: 'Active classes',
  },
  disabledClasses: {
    id: 'schedule-filters.chips.disabled-classes',
    defaultMessage: 'Disabled classes',
  },
  withClientsWaiting: {
    id: 'schedule-filters.chips.with-clients-waiting',
    defaultMessage: 'With clients waiting for spots',
  },
  withNewClients: {
    id: 'schedule-filters.chips.with-new-clients',
    defaultMessage: 'With new clients',
  },
  withReservations: {
    id: 'schedule-filters.chips.with-reservations',
    defaultMessage: 'With reservations',
  },
});
